// extracted by mini-css-extract-plugin
export default {"linkCrowdCellFormContainer":"LinkCrowdCellForm_linkCrowdCellFormContainer__NMaz5"};